var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap wrapper"},[_c('div',{staticClass:"card"},[_vm._v(" "+_vm._s(_vm.fieldRec.form_instance_name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }